export const boutiquesQuery = `{
  boutiques(pageSize: 999, sort: { position: DESC }) {
    items {
      boutique_id
      is_active
      types
      name
      thumbnail
      learn_more_url
      position
      address {
        country_name
        country_id
        region_id
        region
        city
        street
        postcode
        latitude
        longitude
      }
      contacts {
        type
        value
      }
      business_hours {
        weekday {
          id
          label
        }
        opening_time
        closing_time
      }
      business_hours_output
    }
    total_count
  }
}
`;
